// Source: app/scripts/controllers/product-item.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('ProductItemController', [
  '$scope',
  '$translate',
  '$routeParams',
  '$modal',
  '$location',
  'toaster',
  'crudService',
  function($scope, $translate, $routeParams, $modal, $location, toaster, crudService) {
    var service = crudService('product_pictures', {
      getProductPictures: {
        method: 'GET',
        isArray: true,
        url: 'data/rest/product_pictures/by_product/:id'
      }
    });

    $scope.modalCarousel = $modal({
      scope: $scope,
      template: 'forms/modals/show_carousel.html',
      show: false
    });

    $scope.showCarousel = function() {
      service.getProductPictures({id: $scope.entity.id}, function(data) {
        $scope.images = data;
        $scope.modalCarousel.show();
      });
    };

    $scope.previewLot = function() {
      if($scope.close) {
        $scope.close();
      }
      $location.path("user_auctions/lot/" + $scope.entity.lot.auction.id + "/" + $scope.entity.lot.id);
    };
  }]);
